import type {AuthProviderProps} from 'react-oidc-context';
import {getUserManager} from './user-manager';

/**
 * Build the props for react-oidc-context's <AuthProvider>.
 *
 * When a singleton UserManager is available (browser at runtime) we pass it
 * directly — this is the `AuthProviderUserManagerProps` variant.  The same
 * UserManager instance is shared with the API layer so that `signinSilent()`
 * can be called outside of React on 401.
 *
 * During SSR / static build we fall back to a placeholder config.
 */
export function getOidcConfig(): AuthProviderProps {
  const manager = getUserManager();

  if (manager) {
    // AuthProviderUserManagerProps — pass the singleton directly
    return {
      userManager: manager,
      onSigninCallback() {
        globalThis.history.replaceState(
          {},
          document.title,
          globalThis.location.pathname
        );
      },
    };
  }

  // Build-time / SSR placeholder (no window → getUserManager() returns undefined)
  return {
    authority: 'https://placeholder',
    client_id: 'placeholder',
    redirect_uri: 'https://placeholder',
    post_logout_redirect_uri: 'https://placeholder',
  } as AuthProviderProps;
}
